import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { addTestConfig } from '../../../../redux/actions/vacanciesActions.jsx';
import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import { palette } from '../../../../system/styles/styles';
axios.defaults.headers.post.Accept = 'application/json';
axios.defaults.headers['Content-Type'] = 'application/json';
axios.defaults.headers['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE';
axios.defaults.headers['Access-Control-Allow-Headers'] = 'Authorization';

const ShowNotification = (type, content, title) => {
  switch (type) {
    case 'success':
      NotificationManager.success(content, title, 3500);
      break;
    case 'error':
      NotificationManager.error(content, title, 3500);
      break;
    case 'info':
      NotificationManager.info(content, title, 3500);
      break;
    case 'warning':
      NotificationManager.warning(content, title, 3500);
      break;
    default:
      break;
  }
};

const TestStep = (props) => {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    PIP: false,
    Wonderlic: false,
    Terman: false,
    Cleaver: false,
    FP16: false,
    Raven: false,
    preTestConfig: [],
    testAssigned: [],
  });
  const [user, setUser] = useState({
    names: '',
    lastNames: '',
    userID: '',
    linkSended: false,
    email: '',
    testStatus: false,
  });
  const [vacancy, setVacancy] = useState({
    jobTitle: '',
    jobID: '',
    testCreated: false,
  });
  const vacancies = useSelector((state) => state.vacancies);
  const company = useSelector((state) => state.company);
  const platform = useSelector((state) => state.platform);

  useEffect(() => {
    if (props.objectID !== '') {
      let vacancyFinded = vacancies.find((item) => item.jobID === props.id);
      let testAssigned = !!vacancyFinded.testAssigned ? vacancyFinded.testAssigned : [];
      let userFinded = testAssigned.find((item) => item === props.data.objectID);
      setVacancy((prevState) => ({
        ...prevState,
        ...vacancyFinded,
      }));
      setUser((prevState) => ({
        ...prevState,
        ...props.data,
        testAssigned: !!userFinded,
      }));
      if (!!vacancyFinded.testConfig) {
        let prevConfig = !!vacancyFinded.testConfig ? vacancyFinded.testConfig : [];
        setState((prevState) => ({
          ...prevState,
          ...vacancyFinded.testSelected,
          preTestConfig: prevConfig,
          testAssigned: testAssigned,
        }));
      }
      if (!!userFinded) {
        let jobID = vacancy.jobID.replace(/-/g, ' ');
        axios
          .request({
            url: `https://us-central1-universia-prod.cloudfunctions.net/psicoweb-verify-status`,
            method: 'POST',
            crossDomain: true,
            data: { objectID: props.data.objectID.replace(/-/g, ' '), jobID: props.id },
          })
          .then((res) => {
            const response = res.data.message;
            const testStatus = response === 'Link Generado.';
            const link = testStatus ? res.data.data.link : '';
            setUser((prevState) => ({
              ...prevState,
              testStatus: testStatus,
              link: link,
            }));
            console.log(response);
          });
      }
    }
  }, [props, setState]);
  const { className } = props;

  const onChange = (e) => {
    const target = e.target;
    const value = target.checked;
    const name = target.name;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const bodyMailNotification = (genratedLink, data) =>
    platform.customEmails
      ? {
          fromEmail: `${platform.fromEmail}`,
          destiny: user.email,
          subject: `Notificación | Bolsa de trabajo de ${platform.platformName}`,
          body: `<br />
            <p style="font-size: 18px; font-weight: 600;">Hola ${data.userName},</p>
            <br />
            <p style="font-size: 18px;">
            Como parte del proceso de selección a la vacante <strong>${data.vacancyName}</strong> 
            a la cual aplicaste es necesario contestar 
            las siguientes evaluaciones psicométricas:
            </p>
            <br />
            <a style="font-size: 18px;text-decoration: none; background-color: #180e8a; padding: 8px 34px; border-radius: 6px; color:white;" target="_blank" rel="noreferrer noopener" href="${genratedLink}">
                Hacer tests
            </a>
            <br />
            <p style="font-size: 18px;">¡Te deseamos mucho éxito!</p>
            <br />
            <img width="160px" src=${platform.customEmailsLogo} />
           <br />
           <p style="font-size: 14px;">¿Ya nos sigues?</p>
           <br />
           ${
             platform.facebookLink &&
             `<a styles="margin: 7px" href=${platform.facebookLink}>
                  <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png"/>
                </a>`
           }
           ${
             platform.twitterLink &&
             `<a styles="margin: 7px" href=${platform.twitterLink}>
                  <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png"/>
                </a>`
           }
            ${
              platform.instagramLink &&
              `<a styles="margin: 7px" href=${platform.instagramLink}>
                  <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png"/>
                </a>`
            }
            ${
              platform.linkedinLink &&
              `<a styles="margin: 7px" href=${platform.linkedinLink}>
                  <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png"/>
                </a>`
            }
            `,
        }
      : {
          destiny: user.email,
          subject: `Notificación | Bolsa de trabajo de ${platform.platformName}`,
          body: `<br />
            <p style="font-size: 18px; font-weight: 600;">Hola ${data.userName},</p>
            <br />
            <p style="font-size: 18px;">
            Como parte del proceso de selección a la vacante <strong>${data.vacancyName}</strong> 
            a la cual aplicaste es necesario contestar 
            las siguientes evaluaciones psicométricas:
            </p>
            <br />
            <a style="font-size: 18px;text-decoration: none; background-color: #180e8a; padding: 8px 34px; border-radius: 6px; color:white;" target="_blank" rel="noreferrer noopener" href="${genratedLink}">
                Hacer tests
            </a>
            <br />
            <p style="font-size: 18px;">¡Te deseamos mucho éxito!</p>
            <br />
            <img width="140px" src="https://firebasestorage.googleapis.com/v0/b/universia-prod.appspot.com/o/defaultImages%2Flogo-dark.37c08620.png?alt=media&token=b1c8657c-4e50-404f-8736-ae15aa0bdd29" />
            <br />
            <p style="font-size: 14px;">¿Ya nos sigues?</p>
            <br />
            <a styles="margin: 7px" href="https://www.facebook.com/lapieza.io/">
                <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png">
            </a>
            <a styles="margin: 7px" href="https://twitter.com/lapiezaio?lang=es">
                <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png">
            </a>
            <a styles="margin: 7px" href="https://www.instagram.com/lapieza.io/">
                <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png">
            </a>
            <a styles="margin: 7px" href="https://ar.linkedin.com/company/lapieza">
                <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png">
            </a>`,
        };

  const sendLink = () => {
    let testSendConfig = [];
    const { Raven, PIP, Wonderlic, Terman, Cleaver, FP16 } = state;
    if (state.Raven) {
      testSendConfig.push('Raven');
    }
    if (state.FP16) {
      testSendConfig.push('FP16');
    }
    if (state.Cleaver) {
      testSendConfig.push('Cleaver');
    }
    if (state.Terman) {
      testSendConfig.push('Terman');
    }
    if (state.Wonderlic) {
      testSendConfig.push('Wonderlic');
    }
    if (state.PIP) {
      testSendConfig.push('PIP');
    }

    let jobIDNS = vacancy.jobID.replace(/-/g, ' ');

    let testAssigned = state.testAssigned;
    let testCreated = vacancy.testCreated;
    testAssigned.push(user.objectID);
    if (testSendConfig.length >= 1) {
      const data = {
        createPosition: !testCreated,
        userName: user.names,
        position: jobIDNS,
        userID: user.objectID,
        userLastName: user.lastNames,
        userDate: '1990-01-01',
        userEmail: user.email,
        assignedTests: testSendConfig,
        date: '2021-01-29',
        phoneNumber: user.phoneNumber,
      };
      axios
        .request({
          url: 'https://us-central1-universia-prod.cloudfunctions.net/psicoweb-generateLink',
          method: 'POST',
          data: data,
          crossDomain: true,
        })
        .then((res) => {
          if (res.data.message === 'Link Generado.') {
            const configData = {
              testConfig: testSendConfig,
              vacancyData: vacancy,
              testSelected: { Raven, FP16, PIP, Wonderlic, Cleaver, Terman },
              testAssigned: testAssigned,
              testCreated: !testCreated,
            };
            const testData = {
              assignedTests: testSendConfig,
              position: vacancy.jobID,
              userID: user.objectID,
              vacancyOwner: vacancy.vacancyOwner,
              userName: user.names,
              userLastName: user.lastNames,
              companyEmail: company.companyEmail,
              platform: platform.platformName,
              vacancyName: vacancy.jobTitle,
            };
            dispatch(addTestConfig({ ...configData, testData }));
            const link = res.data.data.link;
            axios
              .request({
                url: 'https://us-central1-universia-prod.cloudfunctions.net/sendEmailHTML',
                method: 'POST',
                data: bodyMailNotification(link, testData),
                crossDomain: true,
              })
              .then((res) => {
                ShowNotification('success', 'Se envio correctamente al postulante', 'Se envió el Link');
                console.log('Email Sent');
              });
            setUser((prevState) => ({
              ...prevState,
              testAssigned: true,
            }));
          } else {
            console.log(res);
            ShowNotification(
              'warning',
              'Ocurrió un error inesperado intentalo más tarde',
              'No se pudo asignar la prueba tecnica'
            );
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      ShowNotification('warning', 'Debes seleccionar al menos una prueba', 'No has seleccionado ninguna prueba');
    }
  };

  return (
    <article className={className}>
      {vacancy.testCreated ? (
        <label className="title">
          Las pruebas psicométricas para esta vacante ya fueron configuradas y no pueden ser editadas.
        </label>
      ) : (
        <label className="title">
          Elige las evaluaciones psicométricas que deseas enviar al candidato. Estas evaluaciones solo se pueden
          configurar una vez por vacante una vez configuradas no podrás editarlas.
        </label>
      )}
      <div className="checkbox-list">
        <div className="checkbox-item">
          <div className="checkbox">
            <label>
              <input
                disabled={vacancy.testCreated}
                name="PIP"
                checked={state.PIP}
                type="checkbox"
                onChange={onChange}
              />
              PIP
            </label>
          </div>
          <div className="description">
            <label>Sirve como guía en intereses vocacionales y profesionales.</label>
          </div>
        </div>
        <div className="checkbox-item">
          <div className="checkbox">
            <label>
              <input
                disabled={vacancy.testCreated}
                name="Wonderlic"
                checked={state.Wonderlic}
                type="checkbox"
                onChange={onChange}
              />
              Wonderlic
            </label>
          </div>
          <div className="description">
            <label>Mide la capacidad de lógica y razonamiento.</label>
          </div>
        </div>
        <div className="checkbox-item">
          <div className="checkbox">
            <label>
              <input
                disabled={vacancy.testCreated}
                name="Terman"
                checked={state.Terman}
                type="checkbox"
                onChange={onChange}
              />
              Terman
            </label>
          </div>
          <div className="description">
            <label>Determina el cociente intelectual general.</label>
          </div>
        </div>
        <div className="checkbox-item">
          <div className="checkbox">
            <label>
              <input
                disabled={vacancy.testCreated}
                name="Cleaver"
                checked={state.Cleaver}
                type="checkbox"
                onChange={onChange}
              />
              Cleaver
            </label>
          </div>
          <div className="description">
            <label>Sirve para medir estilos de trabajo.</label>
          </div>
        </div>
        <div className="checkbox-item">
          <div className="checkbox">
            <label>
              <input
                disabled={vacancy.testCreated}
                name="FP16"
                checked={state.FP16}
                type="checkbox"
                onChange={onChange}
              />
              FP16
            </label>
          </div>
          <div className="description">
            <label>Test de los 16 Factores de la Personalidad.</label>
          </div>
        </div>
        <div className="checkbox-item">
          <div className="checkbox">
            <label>
              <input
                disabled={vacancy.testCreated}
                name="Raven"
                checked={state.Raven}
                type="checkbox"
                onChange={onChange}
              />
              Raven
            </label>
          </div>
          <div className="description">
            <label>Mide el nivel de inteligencia.</label>
          </div>
        </div>
        <div className="button-container">
          {!!user.testAssigned ? (
            <label>Ya se ha enviado el link a este postulante</label>
          ) : (
            <>
              <button onClick={sendLink}>Enviar</button>
              <label>Se enviará un correo al candidato con la liga de la evaluación.</label>
            </>
          )}
          {user.testStatus ? (
            <a href={user.link} rel="noreferrer noopener" target="_blank">
              Resultados
            </a>
          ) : null}
          {!user.testStatus ? <label>El usuario aún no ha respondido sus test.</label> : null}
        </div>
      </div>
    </article>
  );
};

export default styled(TestStep)`
  margin-top: 24px;
  height: calc(100vh - 190px);
  overflow-y: auto;
  padding: 16px;
  &::-webkit-scrollbar {
    width: 0.5em;
    height: 0.5em;
  }

  &::-webkit-scrollbar-track {
    background-color: #f2f2f2;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 0.5rem;
  }

  .button-container {
    display: flex;
    flex-direction: column;
    width: 85%;
    margin: 20px auto;
    button {
      padding: 8px 30px;
      background-color: #5373fc;
      border-radius: 4px;
      color: white;
      width: 22%;
      font-size: 16px !important;
      border: none;
      cursor: pointer;
    }
    a {
      padding: 8px 30px;
      background-color: #5373fc;
      border-radius: 4px;
      color: white;
      width: 30%;
      font-size: 18px !important;
    }
    label {
      font-size: 16px !important;
      text-align: start;
      font-weight: 300;
    }
  }

  .title {
    font-size: 18px !important;
    width: 90%;
    margin: 20px auto;
    font-family: ${palette.nereg};
    text-align: justify;
  }

  .checkbox-list {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    align-items: center;
    margin: 20px auto;
  }

  .checkbox-item {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin: 10px auto;
    width: 85%;
  }

  .checkbox {
    display: flex;
    width: 30%;
    justify-content: space-between;
    label {
      width: 90%;
      text-align: start;
      font-size: 16px !important;
      font-weight: 600;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    input {
      display: block;
      position: relative;
      transform: scale(1.5);
      color: #0b174d;
      width: auto;
      margin-right: 20px;
    }
  }

  .description {
    width: 70%;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    label {
      font-size: 14px !important;
      font-weight: 400;
      text-align: start;
    }
  }

  p {
    font-size: 14px;
  }
`;
